import { ConditionalWrap } from '@magnetic/higher-order-components';
import { useClassNames } from '@magnetic/hooks';
import { ArrowLeft } from '@magnetic/icons';
import { Tooltip } from '@magnetic/tooltip';
import React, { memo, forwardRef } from 'react';

const BreadcrumbLink = memo(
  forwardRef(
    ({
      as,
      children,
      className,
      href,
      withArrow = false,
      ...rest
    }, ref) => {
      const Component = as != null ? as : "a";
      const classNames = useClassNames(
        "mds-rebuild-breadcrumb-link",
        className
      );
      return /* @__PURE__ */ React.createElement(ConditionalWrap, {
        condition: children.length > 50,
        wrap: (node) => /* @__PURE__ */ React.createElement(Tooltip, {
          title: children
        }, node)
      }, /* @__PURE__ */ React.createElement(Component, {
        ...rest,
        className: classNames,
        href,
        ref
      }, withArrow && /* @__PURE__ */ React.createElement(ArrowLeft, {
        className: "mds-rebuild-breadcrumb-arrow",
        weight: "bold"
      }), children));
    }
  )
);
BreadcrumbLink.displayName = "Breadcrumb.Link";

export { BreadcrumbLink };
//# sourceMappingURL=breadcrumb-link.js.map
